import { NestClientError } from "./client"

const BUSY_RETRY_DELAYS_MS = [50, 100, 200, 400, 800]

function delay(ms: number): Promise<void> {
    return new Promise((resolve) => globalThis.setTimeout(resolve, ms))
}

export function isBusyError(error: unknown): boolean {
    const code = error instanceof NestClientError ? error.code.toLowerCase() : ""
    const message = error instanceof Error ? error.message.toLowerCase() : ""
    return code === "busy" || message.includes("database is locked") || message.includes("sqlite_busy")
}

export async function retryBusy<T>(operation: () => Promise<T>): Promise<T> {
    for (let attempt = 0; ; attempt++) {
        try {
            return await operation()
        } catch (error) {
            if (!isBusyError(error) || attempt >= BUSY_RETRY_DELAYS_MS.length) throw error
            await delay(BUSY_RETRY_DELAYS_MS[attempt])
        }
    }
}
